import Link from "next/link";
import { useTranslation } from "react-i18next";
import ArrowRightSLineIcon from "remixicon-react/ArrowRightSLineIcon";
import cls from "./listHeader.module.scss";

type Props = {
  title?: string;
  href?: string;
};

export default function ListHeader({ title, href }: Props) {
  const { t } = useTranslation();
  return (
    <div className={cls.container}>
      <h2 className={cls.title}>{title}</h2>
      {href && href?.length > 0 && (
        <Link href={href} className={cls.link}>
          <span>{t("see.all")}</span>
          <ArrowRightSLineIcon size={24} />
        </Link>
      )}
    </div>
  );
}
